import { RegisterEmailTranslations } from "#i18n/translations/pt-BR/recovery/register-email";

export const REGISTER_EMAIL_EN_US: RegisterEmailTranslations = {
	registerEmail: "Register an email to continue",
	cardInfo: `We will send you a link to authenticate this email and, after that, you will be able to access 
	normally with your username and password.`,
	description: "It's quick and will be done only once.",
	enterprise: "Company",
	email: "Email",
	emailPlaceholder: "Enter your email",
	enterprisePlaceholder: "Enter your company",
	login: "Username",
	password: "Password",
	confirmPassword: "Confirm password",
	confirm: "Confirm and send email",
	send: "Send",
	backToLogin: "Back to Login",
	sendEmailModal: {
		title: "The email has been sent!",
		subtitle1: "We sent a link to {{email}}",
		subtitle2:
			"Open the email and click on 'Authenticate email' to continue accessing the Dashboard.",
	},
	emailConfirmedModal: {
		title: "The E-mail that you registered has been authenticated!",
		subtitle:
			"You can now access the Dashboard Zig with your username and password normally.",
		makeLogin: "Make login",
	},
	expiredLinkModal: {
		title: "The link has expired!",
		subtitle: "Enter the email again to send a new authentication link.",
		registerEmail: "Register email",
	},
	resendEmail: "Resend email in ({{countDown}})",
	fields: {
		enterprise: {
			required: "The company name is required",
		},
		email: {
			required: "The email is required",
			invalid: "Enter a valid email",
		},
	},
};
